import { render, staticRenderFns } from "./BinderNode.vue?vue&type=template&id=5df8478a&"
import script from "./BinderNode.vue?vue&type=script&lang=js&"
export * from "./BinderNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports